import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { usePageMeta } from '../lib/usePageMeta';
export function Privacy() {
  usePageMeta({
    title: 'Política de Privacidad — Más Años Juntos',
    description: 'Política de privacidad de Más Años Juntos.'
  });
  return <div className="min-h-screen bg-cream-light font-sans text-gray-900" data-id="element-316">
      <header className="bg-white border-b border-sage-light/30" data-id="element-317">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex items-center justify-between" data-id="element-318">
          <Link to="/" className="inline-flex items-center text-sage-dark hover:text-terracotta transition-colors text-sm font-medium" data-id="element-319">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-320" />
            Volver al inicio
          </Link>
          <span className="font-serif font-bold text-lg text-gray-900" data-id="element-321">
            MÁS AÑOS JUNTOS
          </span>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-322">
        <h1 className="text-4xl md:text-5xl font-serif font-bold text-gray-900 mb-4" data-id="element-323">
          Política de Privacidad
        </h1>
        <p className="text-sm text-gray-500 mb-12" data-id="element-324">
          Última actualización: Mayo de 2026
        </p>

        <div className="space-y-8 text-gray-700 leading-relaxed text-lg" data-id="element-325">
          <section data-id="element-326">
            <p data-id="element-327">
              Tu privacidad nos importa. Queremos que sepas con claridad qué
              información recogemos cuando interactúas con nuestra web y cómo la
              usamos para acompañarte mejor a ti y a tu mascota.
            </p>
          </section>

          <section data-id="element-328">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-329">
              1. Información que recogemos
            </h2>
            <p data-id="element-330">
              Cuando realizas una compra, recogemos los datos mínimos
              necesarios: tu nombre y tu correo electrónico. Esta información se
              utiliza únicamente para enviarte el acceso al producto digital,
              actualizaciones del contenido y comunicaciones relacionadas con tu
              experiencia con "Más Años Juntos".
            </p>
          </section>

          <section data-id="element-331">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-332">
              2. Cómo usamos tu información
            </h2>
            <ul className="space-y-2 list-disc pl-6" data-id="element-333">
              <li data-id="element-334">Para entregarte el acceso al producto digital adquirido.</li>
              <li data-id="element-335">
                Para enviarte actualizaciones, nuevos recursos o bonos
                relacionados con el método.
              </li>
              <li data-id="element-336">Para responder a tus consultas o solicitudes de soporte.</li>
              <li data-id="element-337">
                Para mejorar nuestros materiales basándonos en comentarios
                generales de la comunidad.
              </li>
            </ul>
          </section>

          <section data-id="element-338">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-339">
              3. Pagos
            </h2>
            <p data-id="element-340">
              Los pagos se procesan a través de plataformas externas seguras. No
              almacenamos ni tenemos acceso a los datos de tu tarjeta o método
              de pago. Toda la información de pago es gestionada directamente
              por el procesador correspondiente.
            </p>
          </section>

          <section data-id="element-341">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-342">
              4. Compartir con terceros
            </h2>
            <p data-id="element-343">
              No vendemos ni cedemos tus datos personales. Solo compartimos
              información con servicios que nos ayudan a operar (por ejemplo, la
              plataforma de envío de correos o el procesador de pagos), y
              siempre con el único objetivo de entregarte el producto y darte
              soporte.
            </p>
          </section>

          <section data-id="element-344">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-345">
              5. Cookies
            </h2>
            <p data-id="element-346">
              Usamos cookies básicas para que la web funcione correctamente y
              para entender de forma agregada cómo se navega por el sitio. No
              utilizamos cookies para rastrearte fuera de esta web. Puedes
              configurar tu navegador para limitar o bloquear cookies cuando lo
              desees.
            </p>
          </section>

          <section data-id="element-347">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-348">
              6. Tus opciones
            </h2>
            <p data-id="element-349">
              Puedes pedirnos en cualquier momento que actualicemos tus datos o
              que dejemos de enviarte comunicaciones. Cada correo que enviamos
              incluye un enlace para darte de baja con un solo clic.
            </p>
          </section>

          <section data-id="element-350">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-351">
              7. Seguridad
            </h2>
            <p data-id="element-352">
              Tomamos medidas razonables para proteger tu información. Aun así,
              ningún sistema en internet es 100% seguro. Te recomendamos usar
              contraseñas únicas y mantener seguro tu correo electrónico de
              acceso al producto.
            </p>
          </section>

          <section data-id="element-353">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-354">
              8. Cambios en esta política
            </h2>
            <p data-id="element-355">
              Si actualizamos esta política, lo reflejaremos en la fecha que
              aparece arriba. Te animamos a revisarla ocasionalmente para
              mantenerte al día.
            </p>
          </section>

          <section data-id="element-356">
            <h2 className="text-2xl font-serif font-bold text-gray-900 mb-3" data-id="element-357">
              9. Contacto
            </h2>
            <p data-id="element-358">
              Si tienes alguna pregunta sobre cómo manejamos tus datos, puedes
              escribirnos respondiendo al correo de confirmación que recibiste
              tras la compra. Estaremos encantados de ayudarte.
            </p>
          </section>
        </div>

        <div className="mt-16 pt-8 border-t border-sage-light/40" data-id="element-359">
          <Link to="/" className="inline-flex items-center text-sage-dark hover:text-terracotta transition-colors font-medium" data-id="element-360">
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-361" />
            Volver al inicio
          </Link>
        </div>
      </main>
    </div>;
}